import { FC, Suspense, useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { Container } from '@mui/material';

import { useQueryState, useRouter } from '@cvt/routing';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { RESPONSIVE_QUERY_LIMIT } from '@cvt/helpers/query';

import { CreateStory } from './CreateStory';
import { EditStory } from './EditStory';
import { ViewStories } from './ViewStories';


export const Stories: FC = () => {
  const router = useRouter();

  const [type, setType] = useQueryState<Stories.StoryType>('type');
  const [tags, setTags] = useQueryState<string[]>('tags');
  const [status, setStatus] = useQueryState<Stories.StoryStatus>('status');

  const filters = useMemo(() => ({
    type,
    tags,
    status,
    limit: RESPONSIVE_QUERY_LIMIT,
  }), [type, tags, status]);

  const setters = useMemo(() => ({
    type: setType,
    tags: setTags,
    status: setStatus,
  }), [setType, setTags, setStatus]);

  return (
    <Container maxWidth="lg" sx={{ mt: 2, m: 0, width: '100%' }} disableGutters>
      <ErrorBoundary>
        <Suspense fallback={<BodyLoading height="100%"/>}>
          <Routes>
            <Route
              path="/"
              element={<ViewStories filters={filters} setters={setters}/>}
            />
            <Route
              path="/create"
              element={<CreateStory/>}
            />
            <Route
              path="/edit/:storyId"
              element={<EditStory/>}
            />
            <Route path="*" element={<Navigate to={router.stories.path} replace/>}/>
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Container>
  );
};
